import i18next from 'i18next';
import i18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';

/**
 * 対応言語を設定
 */
const Languages = ['en', 'ja', 'kana'] as const;
type LanguageTypes = typeof Languages[number];

export class AbstractTranslation {
  constructor() {
    i18next
      .use(i18nextBrowserLanguageDetector)
      .init({ fallbackLng: 'ja', resources: { en: {}, ja: {}, kana: {} } })
      .then((data) => {
        console.log('i18next', i18next.language, data);
      });

    console.log('i18next', i18next.language);
  }

  // 対応する言語かを判定
  static isAvailable = (name: string): name is LanguageTypes => {
    return Languages.some((value) => value === name);
  };

  /**
   * 現在選択されている言語を返す、リストになければenを返す
   */
  static get language(): LanguageTypes {
    return AbstractTranslation.isAvailable(i18next.language) ? i18next.language : 'en';
  }

  static set language(lang: LanguageTypes) {
    i18next.changeLanguage(lang).catch();
  }

  /**
   * リソースの翻訳を実施する
   * @param defaultJp 日本語のリソース文字列
   * @param key リソースを探すキーワード（リソースファイルのプロパティ名に一致）
   * @returns 翻訳された文字列
   */
  to(defaultJp: string, key: keyof this) {
    if (AbstractTranslation.language === 'ja') return defaultJp;
    console.log(this, this[key]);
    const keyObject = this[key] as any;
    return keyObject[AbstractTranslation.language] as string;
  }
}
